export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT
export const MERCURE_ENDPOINT = import.meta.env.VITE_MERCURE_ENDPOINT
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
export const APP_VERSION = import.meta.env.VITE_APP_VERSION
export const STATS_ID = import.meta.env.VITE_STATS_ID
export const STATS_SCRIPT = import.meta.env.VITE_STATS_SCRIPT
